import axios from 'axios';
import { API_BASE_URL } from './scanApi';

// Prix multi-store (ITAD) pour une liste d'appids Steam.
// Réponse : [{ appId, drmFree, gog:{shop,price,currency,cut,url}|null, offers:[...] }]
export const getMultiStorePrices = (appIds) =>
  axios.post(`${API_BASE_URL}/prices/multistore`, { appIds });
